import Vue from 'vue'
import store from '@/store';

/**
 * 判断用户的角色是否属于显示该布局的角色列表
 * 例：v-permission="'ADMIN, SYSTEM'"
 */
const permission = Vue.directive('permission', {
    inserted: (el, binding) => {
        const myPermission = store.getters.getUserInfo.roles;
        const permission = binding.value.split(',');
        let arr = permission.filter((v) => {
            return myPermission.indexOf(v) !== -1;
        });
        if (arr.length > 0) {
            return;
        } else {
            el.parentNode && el.parentNode.removeChild(el);
        }
    }
})

export default permission;